import { Box, Card, H2, Separator } from '@betterment/samba-react';
import { vstack } from '@betterment/samba-styled-system/patterns';
import { ParentSize } from '@visx/responsive';

import { ProjectionDisclosures } from '../../../../../forecaster/shared/components/ProjectionDisclosures';
import { ForecasterProjectionDisclosuresFragment } from '../../../../../forecaster/shared/graphql/forecasterProjectionDisclosures.generated';
import { LoadingAccountProjectionChart } from '../../../../../Shared/components-v2/loading-Account-projection-chart/LoadingAccountProjectionChart';
import { PurposeProjectionQuery } from '../../graphql/purposeProjection.generated';
import { ForecasterLink } from '../ForecasterLink';
import { ProjectionHighlights } from '../highlights/ProjectionHighlights';

type ProjectionZeroStateProps = {
  purpose: PurposeProjectionQuery['purpose'];
  disclosures: ForecasterProjectionDisclosuresFragment;
};

export const ProjectionZeroState: React.FC<ProjectionZeroStateProps> = ({ purpose, disclosures }) => {
  return (
    <Card>
      <Card.Header css={{ display: 'flex', flexDirection: 'column', padding: 'space.300', gap: 'space.50' }}>
        <H2 variant="title200">Goal progress</H2>
      </Card.Header>
      <Separator css={{ fullWidthWithInset: 'space.300' }} />
      <Card.Content css={{ p: 'space.300' }}>
        <Box css={{ display: 'flex', flexDirection: 'column', gap: 'space.200' }}>
          <Box css={vstack.raw({ gap: 'space.100', alignItems: 'start', minWidth: 'size.0' })}>
            <ParentSize>
              {({ width }) => <LoadingAccountProjectionChart width={width} height={200} variant="zero-state" />}
            </ParentSize>
          </Box>
          <ProjectionHighlights purpose={purpose} />
          <ForecasterLink purpose={purpose} />
          <ProjectionDisclosures disclosures={disclosures} />
        </Box>
      </Card.Content>
    </Card>
  );
};
